/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import * as z from 'zod';
import { paginationSchema } from './core';
/** A single project run (one scenario) or a batch of runs over swept parameters. */
export const projectSimulateRunKinds = ['single', 'sweep'];
export const projectSimulateRunsQuerySchema = paginationSchema.extend({
    limit: z.int().min(1).max(200).default(50),
    kind: z.enum(['all', ...projectSimulateRunKinds]).default('all'),
    /** Only runs started by the caller. */
    mine: z.boolean().optional(),
    search: z.string().trim().max(200).optional(),
    bodOnly: z.boolean().optional(),
    startDate: z.iso.datetime().optional(),
    endDate: z.iso.datetime().optional(),
});
/**
 * Compare id of one scenario of a sweep (`<batch id>:<scenario number>`). Sweep scenarios have no
 * saved scenario of their own; the project compare endpoints read them from the sweep's report.
 */
export const sweepScenarioCompareId = (batchId, scenarioNumber) => `${batchId}:${scenarioNumber}`;
/** The sweep and scenario number of a sweep scenario compare id; null for a scenario id. */
export function parseSweepScenarioCompareId(id) {
    const match = /^([^:]+):(\d+)$/.exec(id);
    return match ? { batchId: match[1], scenarioNumber: Number(match[2]) } : null;
}
//# sourceMappingURL=project-simulate.js.map